import queryString from 'query-string';

interface FinalizeUserQueryString {
  flowKey?: string;
  offcode?: string;
}

export const finalizeUserEmailParams = () => {
  const parsed: FinalizeUserQueryString = queryString.parse(window.location.search);
  if (parsed.flowKey && parsed.offcode) { // NB, query params are case sensitive
    return { flowKey: parsed.flowKey, offcode: parsed.offcode };
  }
  return null;
};
